import React from "react";
import PropTypes from 'prop-types';
import { SelectControl } from '@wordpress/components';

import Base from "../Base";
import withInput from "../../../hoc/withInput";

class SelectInput extends Base {
	getOptions() {
		const { options } = this.props;

		return Object.keys( options ).map( ( optionId ) => ( {
			label: options[optionId],
			value: optionId,
		} ) )
	}
	input() {
		const { inputValue } = this.props;
		
		return(
			<SelectControl value={ inputValue } onChange={ ( newValue ) => {
				this.onChange( newValue );
			} } options={ this.getOptions() } />
		);
	}
}


SelectInput.propTypes = {
	id: PropTypes.string,
	inputValue: PropTypes.string,
	options: PropTypes.object,
};

export default withInput( SelectInput );
